// ============================================================================
// messageWindows.js — mikor KÍNÁLJUK FEL a szerkesztés/törlés gombot
// (2026-10-07, tagi kérésre: a törlés 15 perc; 2026-10-24: a SZERKESZTÉSNEK nincs időkorlátja - Mamoru #53).
//
// A DÖNTÉST a szerver hozza (functions/src/messageActions.js EDIT_WINDOW_MS /
// DELETE_WINDOW_MS) - ez csak azt dönti el, hogy a gomb látszik-e, hogy ne
// kínáljunk fel olyan műveletet, ami biztosan elutasításra kerül (főleg most,
// hogy a két időkeret eltér: a szerkesztés még él, a törlés már nem).
// Az értékeket egy teszt veti össze a szerverével, hogy ne csúszhassanak szét.
//
// ÓRAELTÉRÉS: a kliens órája eltérhet a szerverétől, ezért a határ CLOCK_GRACE_MS
// ráhagyással számít - inkább látszik egy gomb egy percig a kelleténél tovább
// (a szerver ilyenkor érthetően elutasít), mint hogy eltűnjön, amikor még
// használható volna.
// ============================================================================

export const EDIT_WINDOW_MS = null; // null = korlátlan (2026-10-24; a szerver is így dönt: messageActions.js)
export const DELETE_WINDOW_MS = 15 * 60 * 1000;
export const CLOCK_GRACE_MS = 2 * 60 * 1000;

/** Az üzenet küldésének ideje ezredmásodpercben; null, ha még nincs (a szerver-időbélyeg nem érkezett meg). */
export function kuldesIdeje(msg) {
  const ts = msg && msg.createdAt;
  if (!ts) return null;
  if (typeof ts.toMillis === "function") return ts.toMillis();
  if (typeof ts.seconds === "number") return ts.seconds * 1000;
  return typeof ts === "number" ? ts : null;
}

function ablakonBelul(msg, ablakMs, now) {
  const mikor = kuldesIdeje(msg);
  // Még nincs szerver-időbélyeg = épp most küldtük: az ablakon belül van.
  if (mikor === null) return true;
  return now - mikor <= ablakMs + CLOCK_GRACE_MS;
}

export const szerkesztesiIdonBelul = () => true; // a küldő a saját üzenetét bármikor szerkesztheti (a zárolt téma / csak olvasható szoba kizárását a hívó kezeli)
export const torlesiIdonBelul = (msg, now = Date.now()) => ablakonBelul(msg, DELETE_WINDOW_MS, now);
